import React, { useState, useEffect, useRef } from 'react';
import { Card, Alert, Spinner, Button, Table, Badge, Container, Row, Col, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { getFirmaData, submitFirma, downloadFirmaPdf } from '../../api/common';
import FirmaCanvas from './FirmaCanvas';
import './PanelFirmaPublic.css';

const PanelFirmaPublic = () => {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [equipmentData, setEquipmentData] = useState(null);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });
  const [procesando, setProcesando] = useState(false);
  const [firmaGuardada, setFirmaGuardada] = useState(null);
  const [descargandoPdf, setDescargandoPdf] = useState(false);
  
  console.log(equipmentData);
  // Nuevos estados para nombre y cargo
  const [nombrePersona, setNombrePersona] = useState('');
  const [cargoPersona, setCargoPersona] = useState('');

  useEffect(() => {
    cargarDatosFirma();
  }, [token]);

  const cargarDatosFirma = async () => {
    setLoading(true);
    setMensaje({ tipo: '', texto: '' });

    try {
      const response = await getFirmaData(token);
      
      if (response.status === 200 && response.data.data) {
        setEquipmentData(response.data.data);
      } else if (response.status === 410) {
        setMensaje({ 
          tipo: 'warning', 
          texto: 'Este enlace de firma ha expirado. Por favor contacte con BIOLAB para solicitar uno nuevo.' 
        });
      } else if (response.status === 404) {
        setMensaje({ 
          tipo: 'danger', 
          texto: 'Enlace de firma no válido o no encontrado.' 
        });
      } else {
        setMensaje({ 
          tipo: 'danger', 
          texto: response.message || 'Error al cargar los datos de firma' 
        });
      }
    } catch (error) {
      console.error('Error al cargar datos de firma:', error);
      setMensaje({ 
        tipo: 'danger', 
        texto: 'Error de conexión. Por favor intente nuevamente más tarde.' 
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFirmaSave = (firmaDataURL) => {
    setFirmaGuardada(firmaDataURL);
  };

  const handleEnviarFirma = async () => {
    if (!firmaGuardada) {
      alert('Por favor complete su firma antes de enviar');
      return;
    }

    if (!nombrePersona.trim()) {
      alert('Por favor ingrese su nombre completo');
      return;
    }

    if (!cargoPersona.trim()) {
      alert('Por favor ingrese su cargo');
      return;
    }

    if (!window.confirm('¿Confirma que desea enviar su firma?')) {
      return;
    }

    setProcesando(true);

    try {
      const response = await submitFirma(token, firmaGuardada, nombrePersona, cargoPersona, equipmentData._id);
      
      if (response.status === 200) {
        setMensaje({ 
          tipo: 'success', 
          texto: '¡Firma recibida exitosamente! Gracias por confirmar el servicio realizado.' 
        });
        // Actualizar estado local
        setEquipmentData({ 
          ...equipmentData, 
          firmaClienteUrl: firmaGuardada,
          firmaClienteFecha: new Date()
        });
      } else if (response.status === 410) {
        setMensaje({ 
          tipo: 'warning', 
          texto: 'Este enlace ha expirado. Por favor contacte con BIOLAB para solicitar uno nuevo.' 
        });
      } else {
        setMensaje({ 
          tipo: 'danger', 
          texto: response.message || 'Error al enviar la firma' 
        });
      }
    } catch (error) {
      console.error('Error al enviar firma:', error);
      setMensaje({ 
        tipo: 'danger', 
        texto: 'Error al procesar su firma. Por favor intente nuevamente.' 
      });
    } finally {
      setProcesando(false);
    }
  };
const handleDescargarPdf = async () => {
    if (!equipmentData) {
      alert('No hay datos disponibles para descargar');
      return;
    }

    setDescargandoPdf(true);

    try {
      console.log('📥 Descargando PDF para token:', token);
      const response = await downloadFirmaPdf(token);
      
      if (response.status === 200) {
        // Crear blob y descargar
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Confirmacion-Servicio-${equipmentData.numeroOrden}-${equipmentData.visitas}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        
        console.log('✅ PDF descargado exitosamente');
      } else {
        alert('Error al descargar el PDF. Por favor intente nuevamente.');
      }
    } catch (error) {
      console.error('❌ Error descargando PDF:', error);
      alert('Error al descargar el PDF. Por favor intente nuevamente más tarde.');
    } finally {
      setDescargandoPdf(false);
    }
  };

  
  // Estado: Loading
  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Cargando información...</p>
      </Container>
    );
  }

  // Estado: Error o Token inválido
  if (mensaje.texto && !equipmentData) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Alert variant={mensaje.tipo}>
              <i className={`bi bi-${mensaje.tipo === 'danger' ? 'x-circle' : 'exclamation-triangle'} me-2`}></i>
              {mensaje.texto}
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  // Estado: Ya firmado
  const yaFirmado = equipmentData?.firmaClienteUrl;

  return (
    <Container className="py-5 panel-firma-public">
      <Row className="justify-content-center">
        <Col lg={8}>
          {/* Header BIOLAB */}
          <Card className="mb-4 border-0 shadow-sm w-100">
            <Card.Body className="text-center bg-primary text-white w-100">
              <h2 className="mb-0">
                <i className="bi bi-building me-2"></i>
                BIOLAB - Confirmación de Servicio
              </h2>
            </Card.Body>
          </Card>

          {/* Mensaje de éxito/error */}
          {mensaje.texto && (
            <Alert variant={mensaje.tipo} className="mb-4">
              {mensaje.texto}
            </Alert>
          )}

          {/* Información de la Hoja de Trabajo */}
          <Card className="mb-4 shadow-sm w-100">
            <Card.Header className='w-100'>
              <h5 className="mb-0">
                <i className="bi bi-file-text me-2"></i>
                Información de la Hoja de Trabajo
              </h5>
            </Card.Header>
            <Card.Body className="w-100">
              <Table borderless className="mb-0 w-100">
                <tbody>
                  <tr>
                    <td className="fw-bold" style={{ width: '40%' }}>Orden de Trabajo:</td>
                    <td className="fs-5">{equipmentData?.numeroOrden || 'N/A'}-{equipmentData?.visitas || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Cliente:</td>
                    <td>{equipmentData?.cliente?.nombre || 'N/A'}</td>
                  </tr>
                  {equipmentData?.responsable && (
                    <tr>
                      <td className="fw-bold">Técnico Responsable:</td>
                      <td>{equipmentData.responsable.nombre} {equipmentData.responsable.apellido}</td>
                    </tr>
                  )}
                  <tr>
                    <td className="fw-bold">Total de Equipos:</td>
                    <td>
                      <Badge bg="primary" className="fs-6">{equipmentData?.equipos?.length || 0}</Badge>
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold">Estado:</td>
                    <td>
                      <Badge bg={equipmentData?.estado === 'Cerrado' ? 'success' : 'secondary'}>
                        {equipmentData?.estado || 'N/A'}
                      </Badge>
                    </td>
                  </tr>
                  {equipmentData?.fechaCierre && (
                    <tr>
                      <td className="fw-bold">Fecha de Cierre:</td>
                      <td>{moment(equipmentData.fechaCierre).format('DD/MM/YYYY HH:mm')}</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card.Body>
          </Card>

          {/* Lista de Equipos en esta HT */}
          {equipmentData?.equipos && equipmentData.equipos.length > 0 && (
            <Card className="mb-4 shadow-sm w-100">
              <Card.Header className='w-100'>
                <h5 className="mb-0">
                  <i className="bi bi-tools me-2"></i>
                  Equipos Incluidos ({equipmentData.equipos.length})
                </h5>
              </Card.Header>
              <Card.Body className="w-100">
                <Table striped bordered hover responsive className="mb-0 w-100">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Consecutivo</th>
                      <th>Equipo</th>
                      <th>Marca</th>
                      <th>Modelo</th>
                      <th>Serie</th>
                      <th>Inventario</th>
                      <th>Ubicación</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {equipmentData.equipos.map((equipo, idx) => (
                      <tr key={equipo._id || idx}>
                        <td>{idx + 1}</td>
                        <td className="fw-bold text-primary">{equipo.consecutivo}</td>
                        <td>{equipo.item || 'N/A'}</td>
                        <td>{equipo.marca || 'N/A'}</td>
                        <td>{equipo.modelo || 'N/A'}</td>
                        <td>{equipo.serial || 'N/A'}</td>
                        <td>{equipo.inventario || 'N/A'}</td>
                        <td>{equipo.ubicacion || 'N/A'}</td>
                        <td>
                          <Badge bg={equipo.estado === 'Finalizado' ? 'success' : 'warning'}>
                            {equipo.estado}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          )}

          {/* Observaciones */}
          {(equipmentData?.observacion || equipmentData?.equipos?.some(eq => eq.observacion)) && (
            <Card className="mb-4 shadow-sm w-100 border-warning">
              <Card.Header className="bg-warning bg-opacity-10 w-100">
                <h5 className="mb-0 text-warning">
                  <i className="bi bi-chat-left-text me-2"></i>
                  Observaciones
                </h5>
              </Card.Header>
              <Card.Body className="w-100">
                {/* Observación general de la HT */}
                {equipmentData?.observacion && (
                  <div className="mb-3">
                    <div className="d-flex align-items-start">
                      <i className="bi bi-info-circle-fill text-primary me-2 mt-1"></i>
                      <div>
                        <strong className="text-primary">Observación General:</strong>
                        <div className="mt-1 p-3 bg-light rounded border-start border-primary border-3">
                          {equipmentData.observacion}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Observaciones de equipos */}
                {equipmentData?.equipos?.filter(eq => eq.observacion && eq.observacion.trim()).length > 0 && (
                  <div>
                    {equipmentData.observacion && <hr className="my-3" />}
                    <div className="d-flex align-items-start mb-2">
                      <i className="bi bi-gear-fill text-secondary me-2 mt-1"></i>
                      <strong className="text-secondary">Observaciones por Equipo:</strong>
                    </div>
                    <div className="ms-4">
                      {equipmentData.equipos
                        .filter(eq => eq.observacion && eq.observacion.trim())
                        .map((equipo, idx) => (
                          <div key={equipo._id || idx} className="mb-2">
                            <div className="p-2 bg-light rounded border-start border-secondary border-2">
                              <div className="d-flex align-items-center mb-1">
                                <Badge bg="secondary" className="me-2">
                                  {equipo.consecutivo}
                                </Badge>
                                <small className="text-muted">
                                  {equipo.item} - {equipo.marca} {equipo.modelo}
                                </small>
                              </div>
                              <div className="text-dark" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {equipo.observacion}
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          {/* Estado: Ya firmado */}
          {yaFirmado ? (
            <Card className="shadow-sm border-success w-100">
              <Card.Body className="text-center py-5 w-100">
                <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '4rem' }}></i>
                <h4 className="mt-3 text-success">¡Firma Recibida!</h4>
                <p className="text-muted">
                  La firma para esta Hoja de Trabajo ya fue recibida el{' '}
                  {equipmentData.firmaClienteFecha 
                    ? moment(equipmentData.firmaClienteFecha).format('DD/MM/YYYY HH:mm')
                    : 'recientemente'
                  }
                </p>

                {/* Preview de la firma */}
                <div className="mt-4">
                  <Card className="d-inline-block w-100">
                    <Card.Body className="w-100">
                      <p className="text-muted mb-2 small">Firma del cliente:</p>
                      <img 
                        src={equipmentData.firmaClienteUrl} 
                        alt="Firma del cliente" 
                        style={{ maxWidth: '400px', border: '1px solid #dee2e6', borderRadius: '4px' }}
                      />
                    </Card.Body>
                  </Card>
                </div>

                {/* Botón de descarga de PDF */}
                <div className="mt-4 d-grid gap-2">
                  <Button 
                    variant="success" 
                    size="lg"
                    onClick={handleDescargarPdf}
                    disabled={descargandoPdf}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {descargandoPdf ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Descargando...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-download me-2"></i>
                        Descargar PDF Firmado
                      </>
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          ) : (
            /* Estado: Pendiente de firma */
            <>
              <Card className="mb-4 shadow-sm w-100">
                <Card.Header className="bg-light w-100">
                  <h5 className="mb-0">
                    <i className="bi bi-pen me-2"></i>
                    Confirmación de Servicio
                  </h5>
                </Card.Header>
                <Card.Body className="w-100">
                  <p>
                    Por favor confirme que el servicio fue realizado correctamente firmando en el recuadro a continuación.
                  </p>
                  <Alert variant="info" className="mb-3">
                    <i className="bi bi-info-circle me-2"></i>
                    Al firmar, confirma que los <strong>{equipmentData?.equipos?.length || 0} equipos</strong> de esta Hoja de Trabajo fueron entregados en condiciones satisfactorias y que el servicio cumple con lo esperado.
                  </Alert>

                  {/* Campos de nombre y cargo */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <i className="bi bi-person me-2"></i>
                      <strong>Nombre completo de quien recibe *</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ingrese su nombre completo"
                      value={nombrePersona}
                      onChange={(e) => setNombrePersona(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>
                      <i className="bi bi-briefcase me-2"></i>
                      <strong>Cargo *</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Ej: Gerente, Supervisor, Técnico, etc."
                      value={cargoPersona}
                      onChange={(e) => setCargoPersona(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <FirmaCanvas 
                    onSave={handleFirmaSave}
                    label="Firme en el recuadro para confirmar"
                  />

                  {firmaGuardada && nombrePersona && cargoPersona && (
                    <Alert variant="success" className="mt-3">
                      <i className="bi bi-check-circle me-2"></i>
                      Firma capturada correctamente. Haga clic en "Enviar" para confirmar.
                    </Alert>
                  )}
                </Card.Body>
              </Card>

              <div className="d-grid gap-2 w-100">
                <Button 
                  variant="primary" 
                  size="lg"
                  onClick={handleEnviarFirma}
                  disabled={procesando || !firmaGuardada || !nombrePersona.trim() || !cargoPersona.trim()}
                  className="d-flex align-items-center justify-content-center w-100"
                >
                  {procesando ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send me-2"></i>
                      Enviar Firma
                    </>
                  )}
                </Button>
              </div>
            </>
          )}

          {/* Footer */}
          <Card className="mt-4 border-0 bg-light w-100">
            <Card.Body className="text-center text-muted small w-100">
              <p className="mb-1">
                <i className="bi bi-shield-check me-2"></i>
                Su firma es tratada de forma confidencial y segura
              </p>
              <p className="mb-0">
                BIOLAB - Laboratorio de Metrología
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PanelFirmaPublic;
